import { pdfCommissions, pdfTraining1, pdfTraining2, pdfTraining3 } from '@/config'

const referralLink = 'https://aal4.adj.st?adjust_t=v9yo7k0_76x32g3&adjust_campaign=app-test&adjust_deeplink=jumia%3A%2F%2Feg%2F&adjust_redirect=https%3A%2F%2Fwww.jumia.com.eg%2F%3Futm_source%3Djforce%26utm_medium%3Dreferral'

const dashboardGetUpdatedItems = [

  {
    img: 'img/dashboard/magik.png',
    title: {
      key: 'dashboard.other.magic_page'
    },
    link: 'https://www.jumia.com.eg/ar/jforce-best-deals/',
    newPage: true
  }
]

const dashboardContactTheTeamItems = [
  {
    img: 'img/dashboard/contact-form.svg',
    title: {
      key: 'dashboard.your.claim'
    },
    subtitle: {
      text: 'dashboard.claim_form.subtitle',
      isKey: true
    },
    link: 'https://forms.gle/jXMYBp85duLVdQvw7',
    newPage: true
  },
  {
    img: 'img/dashboard/icon-telegram.svg',
    title: {
      key: 'dashboard.label.telegram',
      placeholderValue: '#1'
    },
    link: 'https://t.me/JforceEG',
    newPage: true
  },
  {
    img: 'img/dashboard/whatsapp.svg',
     title: {
      key: 'dashboard.contact.whatsapp'
    },
    link: 'http://wa.me/+201019884474',
    newPage: true
  },
  {
    img: 'img/dashboard/icon-facebook.svg',
     title: {
      key: 'dashboard.join.via_facebook'
    },
    link: 'https://www.facebook.com/groups/JForce.EG',
    newPage: true
  },

]

const dashboardOtherItems = [
  {
    img: 'img/dashboard/agreement.svg',
    title: {
      key: 'dashboard.other.agreement'
    },
    newPage: false,
    internalResource: true,
    link: ''
  },

]

export {
  referralLink,
  dashboardGetUpdatedItems,
  dashboardContactTheTeamItems,
  dashboardOtherItems
}
